import React from 'react';
import { normalizeDocumentStatus } from './workflowConstants';

export function getWorkflowStatusBadgeClasses(status: string): string {
  const s = normalizeDocumentStatus(status || '');
  switch (s) {
    case 'published':
      return 'bg-green-100 text-green-800 border-green-200';
    case 'edit':
      return 'bg-gray-100 text-gray-800 border-gray-200';
    case 'archived':
      return 'bg-slate-100 text-slate-800 border-slate-200';
    case 'review':
      return 'bg-yellow-100 text-yellow-800 border-yellow-200';
    case 'signature':
      return 'bg-indigo-100 text-indigo-900 border-indigo-200';
    default:
      return 'bg-gray-100 text-gray-800 border-gray-200';
  }
}

export function getWorkflowStatusLabel(status: string): string {
  const s = normalizeDocumentStatus(status || '');
  switch (s) {
    case 'published':
      return 'Publicado';
    case 'edit':
      return 'Rascunho';
    case 'archived':
      return 'Arquivado';
    case 'review':
      return 'Em revisão';
    case 'signature':
      return 'Assinatura';
    default:
      return status || '—';
  }
}

export const WorkflowStatusBadge: React.FC<{ status: string }> = ({ status }) => (
  <span
    className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${getWorkflowStatusBadgeClasses(
      status
    )}`}
  >
    {getWorkflowStatusLabel(status)}
  </span>
);
